import React from 'react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
import { ArrowRight, Leaf } from 'lucide-react';
export function FinalCTA() {
  return <section id="pricing-cta" className="py-24 bg-white relative overflow-hidden" data-id="element-37">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-38">
        <div className="absolute -right-20 top-20 w-64 h-64 bg-terracotta/5 rounded-full blur-3xl" data-id="element-39"></div>
        <div className="absolute -left-20 bottom-20 w-64 h-64 bg-sage/10 rounded-full blur-3xl" data-id="element-40"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-cream rounded-3xl p-8 md:p-16 shadow-xl shadow-sage/10 border border-sage/10" data-id="element-42">
          <div className="flex justify-center mb-6" data-id="element-43">
            <Leaf className="h-12 w-12 text-terracotta" data-id="element-44" />
          </div>

          <h2 className="text-3xl md:text-5xl font-bold text-forest mb-6 leading-tight" data-id="element-45">
            Esta noche, cuando tu hijo te necesite,{' '}
            <br className="hidden md:block" data-id="element-46" />
            <span className="text-terracotta" data-id="element-47">vas a estar preparada.</span>
          </h2>

          {/* Pricing with discount */}
          <div className="mb-8" data-id="element-48">
            <div className="inline-flex flex-col items-center bg-white rounded-2xl px-6 py-4 shadow-sm border border-sage/15 mb-4 gap-2" data-id="element-49">
              <span className="text-sm font-semibold text-white bg-terracotta rounded-full px-3 py-1 uppercase tracking-wide" data-id="element-50">
                Oferta
              </span>
              <div className="flex items-center gap-3" data-id="element-51">
                <span className="text-forest/40 line-through text-[18px]" data-id="element-52">
                  $19 USD
                </span>
                <span className="font-bold text-forest text-[24px]" data-id="element-53">
                  $6.39 USD
                </span>
              </div>
            </div>
            <p className="text-lg text-forest/70 max-w-2xl mx-auto" data-id="element-54">
              Puedes tener claridad, calma y herramientas naturales ahora mismo
              por un precio especial.
            </p>
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-55">
            <Button variant="primary" size="xl" href="https://www.novarapress.com/cart/46305894629516:1" className="w-full md:w-auto min-w-[300px] shadow-terracotta/30" data-id="element-56">
              Quiero estar preparada <ArrowRight className="ml-2 h-6 w-6" data-id="element-57" />
            </Button>

            <div className="flex flex-wrap justify-center gap-4 text-sm text-forest/60 font-medium mt-4" data-id="element-58">
              <span data-id="element-59">• Descarga inmediata</span>
              <span data-id="element-60">• Formato PDF</span>
              <span data-id="element-61">• Garantía 7 días</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}